"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuleSetRevisionInputSerializer = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const revisions_1 = require("../revisions");
const getRuleSetRevisionInputSerializer = () => {
    const ruleSetSerializer = (0, revisions_1.getRuleSetRevisionSerializer)();
    return (0, serializers_1.mapSerializer)((0, serializers_1.bytes)({ size: (0, serializers_1.u32)() }), (revision) => {
        if ((0, umi_1.isNone)(revision))
            return new Uint8Array();
        return ruleSetSerializer.serialize(revision.value);
    }, (buffer) => {
        if (buffer.length === 0)
            return (0, umi_1.none)();
        const [ruleSet] = ruleSetSerializer.deserialize(buffer, 4);
        return (0, umi_1.some)(ruleSet);
    });
};
exports.getRuleSetRevisionInputSerializer = getRuleSetRevisionInputSerializer;
//# sourceMappingURL=ruleSetRevisionInput.js.map